import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';
import { environment } from '@environments/environment';
import { new_apis } from '@environments/new_apis';
import { IResponse } from '@interfaces/index';
import { CookieService } from 'ngx-cookie-service';


@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private api_legacy: string = environment.api_legacy;
  private api: string = environment.api;

  constructor(
    private http: HttpClient,
    protected cookie_service: CookieService
  ) {}

  protected _createHeaders(): HttpHeaders {
    const token = this.cookie_service.get('access_token');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }

  protected _getFullUrl(url: string): string {
    let api = this.api_legacy;
    if (new_apis.includes(url)) { // using this to redirect to new api if endpoint has been moved over
      api = this.api;
    }
    return `${api}/api/${url}`;
  }

  get<T>(url: string, params?: HttpParams): Observable<IResponse<T>> {
    const full_url = this._getFullUrl(url)
    const headers = this._createHeaders();
    return this.http.get<T>(full_url, { params, headers }).pipe(
      catchError(
        (response: any) => {
          if(response.code === 401 && response.url != environment.api_legacy + '/api/auth/login') {
            location.assign(environment.access)
          }
          throw response;
        }
      )
    ) as Observable<IResponse<T>>;
  }

  post<T>(url: string, data: any): Observable<IResponse<T>> {
    const full_url = this._getFullUrl(url)
    const headers = this._createHeaders();
    return this.http.post<T>(full_url, data, { headers }).pipe(
      catchError(
        (response: any) => {

          if(response.code === 401 && response.url != environment.api_legacy + '/api/auth/login') {
            location.assign(environment.access)
          }
          return of({ code: response.status, message: response.error.message });
        }
      )
    ) as Observable<IResponse<T>>
  }

  // Mirrors `get`'s catchError: server errors are rethrown so callers can branch on
  // them. `post` deliberately does not — see the recorded drift; do not copy it here.
  put<T>(url: string, data: any): Observable<IResponse<T>> {
    const full_url = this._getFullUrl(url)
    const headers = this._createHeaders();
    return this.http.put<T>(full_url, data, { headers }).pipe(
      catchError(
        (response: any) => {
          if(response.code === 401 && response.url != environment.api_legacy + '/api/auth/login') {
            location.assign(environment.access)
          }
          throw response;
        }
      )
    ) as Observable<IResponse<T>>;
  }

  download(url: string, data: any): Observable<Blob> {
    const full_url = this._getFullUrl(url)
    const token = this.cookie_service.get('access_token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    });

    return this.http.post(full_url, data, { headers, responseType: 'blob' })
  }

}